import { Component, Input, OnInit } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-evaluator-calibration-settings',
    templateUrl: './evaluator-calibration-settings.component.html',
    styleUrls: ['./evaluator-calibration-settings.component.scss']
})
export class EvaluatorCalibrationSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;
    varianceScaleValue: number;

    constructor(
        private cvLocalizationService: CVLocalizationService,
    ) { }
    async ngOnInit() {
        await this.cvLocalizationService.GetSection('Calibration_Widgets');
        this.moduleManager.addSetting({
            name: 'varianceScaleValue',
            required: true,
            onMissingValue: () => {
                this.varianceScaleValue = 5;
            },
            getValue: () => this.varianceScaleValue,
            onSettingLoaded: value => {
                this.varianceScaleValue = value;
            },
            defaultValue: 5
        });
        this.moduleManager.customSettingsAdded = true;
    }
}
